module.exports = __webpack_public_path__ + "img/pharmacie.f8288b71.png";